import { Box, Link, Image } from '@alto-avios/alto-ui';
import { FC, useState } from 'react';
import { useVariableValue } from '@devcycle/react-client-sdk';

import { HEADER } from '../../consts';
import { pushGTMEvent, pushtoGTM } from '../../utilities';
import { HeaderContent, LocaleContent, MarketContent, useRequiredContent } from '../services/content';
import { PreferencesSelector } from '../PreferencesSelector';
import { ModalShell } from '../Modal/ModalShell';
import { useUIString } from '../services/content/hooks/useUIString';

export const DesktopBannerContentLinks: FC = () => {
  const hasMultiOpco = useVariableValue('multi-opco-login', false);

  const {
    data: {
      helpCentre: { label, url },
    },
  } = useRequiredContent(HeaderContent);
  const {
    data: { shortLabel, image },
  } = useRequiredContent(MarketContent);
  const {
    data: { label: locale },
  } = useRequiredContent(LocaleContent);

  const [isModalOpen, setModalOpen] = useState(false);

  const preferencesModalOpenLinkAriaLabel = useUIString('preferencesModalOpenLinkAriaLabel');
  const preferencesModalTitle = useUIString('preferencesModalTitle');
  const dialogDismissAriaLabel = useUIString('dialogDismissAriaLabel');

  return (
    <Box borderWidth="none" gap="sm">
      {hasMultiOpco && (
        <Box borderWidth="none" gap="3xs">
          {shortLabel && (
            <>
              <Link
                aria-label={preferencesModalOpenLinkAriaLabel}
                size="sm"
                underline={false}
                iconEndProps={false}
                onPress={() => (setModalOpen(true), pushGTMEvent(HEADER, `${shortLabel} - ${locale}`))}
              >
                {image && <Image src={image.url} alt={image.title} />}
                {shortLabel} - {locale}
              </Link>
              <ModalShell
                heading={preferencesModalTitle}
                isOpen={isModalOpen}
                onClose={() => (pushtoGTM('ctaEvent', 'modal - preferences', 'cta', 'close modal'), setModalOpen(false))}
                ariaLabel={preferencesModalTitle}
                closeButtonAriaLabel={dialogDismissAriaLabel}
              >
                <PreferencesSelector />
              </ModalShell>
            </>
          )}
        </Box>
      )}
      <Link aria-label={label} href={url} iconEndProps={false} onPress={() => pushGTMEvent(HEADER, label)} size="sm" underline={false}>
        {label}
      </Link>
    </Box>
  );
};
